import PdfImagesV2 from '../PdfImages/PdfImagesV2';
import PdfImages from '../PdfImages/PdfImages';
import { appConfig } from '../../../configs/app-config';
import { API_VERSION } from '../../../constants/api-constants';

export const PdfImagesView = appConfig.apiVersion === API_VERSION.V2 ? PdfImagesV2 : PdfImages;
